import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  matchRoutes,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
} from 'react-router-dom';
import { getSentryDsn, getEnv, isProductionEnv } from '#config';

const dsn = getSentryDsn();
const ignoreErrors = [];

Sentry.init({
  dsn,
  ignoreErrors,
  tracesSampleRate: 0.1,
  tracePropagationTargets: [/^\//, /^https:\/\/api\.flowwer\.dev/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  environment: getEnv(),
  debug: !isProductionEnv(),
});
